import { render, staticRenderFns } from "./DeleteLabel.vue?vue&type=template&id=69aa0f83"
import script from "./DeleteLabel.vue?vue&type=script&lang=js"
export * from "./DeleteLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports